import React from "react";
import './heading.css';

const Heading = (props) => {
    return(
        <div>
            <h6 className="SP---Globel--sub-heading mb-0">{props.subtitle}</h6>
            <h2 className="SP---Globel--main-heading mt-2 mb-4" style={{maxWidth:props.mWidth}}>{props.title}</h2>
        </div>
    )
}

export default Heading;